import {getSignUpUrl} from "./url";

export async function signUp(phone: string, locale: string) {
	const response = await window.fetch(getSignUpUrl(), {
		method: "post",
		body: JSON.stringify({
			phone,
			locale,
		}),
		headers: {
			"Content-type": "application/json",
		},
	});
	return await response.json();
}
